/**
 * Calculates an exponential backoff delay for retry attempts.
 *
 * @param failureCount - The number of consecutive failures that have occurred
 * @returns The delay in milliseconds, capped at 30000ms (30 seconds)
 *
 * @remarks
 * The delay is calculated using the formula: min(1000 * 2^failureCount, 30000)
 * - First retry: 2000ms (2s)
 * - Second retry: 4000ms (4s)
 * - Third retry: 8000ms (8s)
 * - Fourth retry: 16000ms (16s)
 * - Fifth+ retry: 30000ms (30s, max cap)
 */
export function backoffDelay(failureCount: number) {
  return Math.min(1000 * 2 ** failureCount, 30000);
}
